@if (!consentGiven) {
  <div class="cookie-popup" [ngClass]="{'french': currentLang === 'fr'}">
    <div class="cookie-popup-content">
      <!-- Title & Message Section -->
      <div class="message">
        <h2 class="message-title">
          {{ translations[currentLang].newMessage.split('\n')[0] }}
        </h2>
        <p class="message-body">
          @for (line of translations[currentLang].newMessage.split('\n').slice(1); track line) {
            <span>
              {{ line }}<br />
            </span>
          }
        </p>
      </div>
      <!-- Slide-Down Category Section -->
      @if (showModal) {
        <div class="slide-in-categories">
          <!-- ESSENTIAL -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('essential')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].essential }}</h3>
                </ion-label>
                <ion-toggle slot="end" checked disabled></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'essential') {
                <div class="category-description">
                  {{ translations[currentLang].essentialDescription }}
                </div>
              }
            </div>
          </div>
          <!-- FUNCTIONAL -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('functional')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].functional }}</h3>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="preferences.functional"></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'functional') {
                <div class="category-description">
                  {{ translations[currentLang].functionalDescription }}
                </div>
              }
            </div>
          </div>
          <!-- ANALYTICS -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('analytics')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].analytics }}</h3>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="preferences.analytics"></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'analytics') {
                <div class="category-description">
                  {{ translations[currentLang].analyticsDescription }}
                </div>
              }
            </div>
          </div>
          <!-- PERFORMANCE -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('performance')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].performance }}</h3>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="preferences.performance"></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'performance') {
                <div class="category-description">
                  {{ translations[currentLang].performanceDescription }}
                </div>
              }
            </div>
          </div>
          <!-- ADVERTISEMENT -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('advertisement')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].advertisement }}</h3>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="preferences.advertisement"></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'advertisement') {
                <div class="category-description">
                  {{ translations[currentLang].advertisementDescription }}
                </div>
              }
            </div>
          </div>
          <!-- UNCATEGORIZED -->
          <div class="consent-section">
            <div class="category-box" (click)="toggleDetails('uncategorized')">
              <ion-item lines="full" class="toggle-row">
                <ion-label>
                  <h3>{{ translations[currentLang].uncategorized }}</h3>
                </ion-label>
                <ion-toggle slot="end" [(ngModel)]="preferences.uncategorized"></ion-toggle>
              </ion-item>
              @if (selectedCategory === 'uncategorized') {
                <div class="category-description">
                  {{ translations[currentLang].uncategorizedDescription }}
                </div>
              }
            </div>
          </div>
          <!-- BUTTONS BELOW CATEGORIES -->
          <div class="button-row-inline">
            <button (click)="onRejectAll()">
              {{ translations[currentLang].reject }}
            </button>
            <button (click)="onSave()">
              {{ translations[currentLang].save }}
            </button>
            <button (click)="onAcceptAll()">
              {{ translations[currentLang].accept }}
            </button>
          </div>
        </div>
      }
      <!-- Buttons (initial view) -->
      @if (!showModal) {
        <div class="button-group">
          <button (click)="onRejectAll()">
            {{ translations[currentLang].reject }}
          </button>
          <button (click)="onCustomize()">
            {{ translations[currentLang].customize }}
          </button>
          <button (click)="onAcceptAll()" class="buttonColoring">
            {{ translations[currentLang].accept }}
          </button>
        </div>
      }
    </div>
  </div>
}
